import type { OriginalInput, SuggestionItem, Setting, SupportedTargetLanguage, GetTechTopicRequest, GetSuggestionsRequest, TaskInfo, GetTranslationAsyncStatusResponse, PutTranslationTextRequest, ExportTranslationRequest, TranslationOriginalRequest } from '@/services/ai-translation/type/ai-translation.type';

export interface ApiGetTechTopicRequest {
    input: string;
    sourceLang: SupportedTargetLanguage | null;
    targetLang: SupportedTargetLanguage | null;
    taskId: string;
    currentStep: string;
}

export interface ApiGetTechTopicResponse {
    techTopic: string;
}



export const GetSettings = Symbol('GetSettings');
export interface GetSettings {
    getSettings: (value: OriginalInput) => Promise<Setting>;
}

export const CheckSensitiveWordDTO = Symbol('CheckSensitiveWordDTO');
export interface CheckSensitiveWordDTO {
    fetch: (value: string) => Promise<string>;
}

export const GetTechTopicDTO = Symbol('GetTechTopicDTO');

export interface GetTechTopicDTO {
    fetch: (value: GetTechTopicRequest) => Promise<string>;
}


export const GetSuggestionsDTO = Symbol('GetSuggestionsDTO');
export interface GetSuggestionsDTO {
    fetch: (value: GetSuggestionsRequest) => Promise<SuggestionItem[]>;
}

export const AddTranslationAsyncTaskDTO = Symbol('AddTranslationAsyncTaskDTO');
export interface AddTranslationAsyncTaskDTO {
    fetch: (value: TaskInfo) => Promise<void>;
}

export const GetTranslationAsyncStatusDTO = Symbol('GetTranslationAsyncStatusDTO');
export interface GetTranslationAsyncStatusDTO {
    fetch: (taskId: string) => Promise<GetTranslationAsyncStatusResponse>;
}

export const PutTranslationTextDTO = Symbol('PutTranslationTextDTO');
export interface PutTranslationTextDTO {
    fetch: (value: PutTranslationTextRequest) => Promise<void>;
}

// export const ExportTranslationDTO = Symbol('ExportTranslationDTO');
export const ExportTranslationDTO = Symbol('ExportTranslationDTO');
export interface ExportTranslationDTO {
    fetch: (value: ExportTranslationRequest) => Promise<string>;
}

export const TranslationSyncDTO = Symbol('TranslationSyncDTO');
export interface TranslationSyncDTO {
    fetch: (value: TaskInfo) => Promise<void>;
}

export const TranslationOriginalDTO = Symbol('TranslationOriginalDTO');
export interface TranslationOriginalDTO {
    fetch: (value: TranslationOriginalRequest) => Promise<void>;
}